export default "__VITE_ASSET__DPeavE6Z__"